// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"d0a7dbd4","160":"17b13295","208":"6ef98930","293":"02bf285a","453":"d706d726","516":"a88a219f","519":"ea05e5d5","917":"949bd2e0","946":"65218fe6"}[chunkId] + ".chunk.js";
};